const messages = {
  step3: {
    actionBtn: "Iniciar sessão",
  },
};

export default {
  messages,
};
